import axios, { AxiosError } from 'axios';
import { showErrorMessage } from '../components/Toaster';

function handleAxiosError(error: AxiosError): void {
  // Simplified error message.
  showErrorMessage(JSON.stringify(error.response?.data));
}

export function handleError(error: Error): void {
  if (axios.isCancel(error)) {
    return;
  }

  if (!axios.isAxiosError(error)) {
    showErrorMessage('Unknown error.');
    return;
  }

  handleAxiosError(error);
}

function handlePromiseRejectionEvent(event: PromiseRejectionEvent): void {
  const { reason: error } = event;

  handleError(error);

  if (process.env.NODE_ENV === 'production') {
    event.preventDefault();
  }
}

export default function registerUnhandledRejection(): void {
  window.addEventListener('unhandledrejection', handlePromiseRejectionEvent);
}
